import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from '../app.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ErrorComponent } from './error/error.component';

const routes: Routes = [
  { path: 'password', pathMatch: 'full', component: ResetPasswordComponent },
  {
    path: 'public',
    component: AppComponent,
    children: [
      {
        path: 'error',
        component: ErrorComponent,
        data: {
          title: 'Error Page',
        },
      },
      {
        path: 'login/',
        component: LoginComponent,
        data: {
          title: 'Login Page',
        },
      },
      {
        path: 'forgot',
        component: ForgotPasswordComponent,
        data: {
          title: 'Forgot password',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
